export default {
  state: {},
  getters: {},
  mutations: {}
}
